import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  Paper,
  InputAdornment,
  Box,
} from "@mui/material";
import { currencies } from "../currencies"; // Import currencies

function ExpenseTable({ expenses, updateExpense, addRow, removeRow, currency }) {
  const handleAmountChange = (index) => (e) => {
    let next = e.target.value;
    if (next === '') {
      updateExpense(index, "amount", '');
      return;
    }
    if (/^0[0-9]+/.test(next) && !next.startsWith('0.')) {
      next = next.replace(/^0+/, '');
    }
    updateExpense(index, "amount", next);
  };

  const handleAmountBlur = (index) => () => {
    const current = expenses[index]?.amount;
    if (current === '') {
      updateExpense(index, "amount", '0');
    }
  };

  return (
    <TableContainer component={Paper} style={{ marginTop: 20 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ padding: '8px' }}>Item</TableCell> {/* Changed from Label to Item */}
            <TableCell style={{ padding: '8px' }}>Amount</TableCell>
            <TableCell style={{ padding: '8px' }} align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {expenses.map((expense, index) => (
            <TableRow key={index} style={{ height: '40px' }}>
              <TableCell style={{ padding: '8px' }}>
                <TextField
                  type="text"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ minWidth: 220 }}
                  value={expense.label}
                  onChange={(e) => updateExpense(index, "label", e.target.value)}
                  InputLabelProps={{ sx: { fontSize: 14 } }}
                />
              </TableCell>
              <TableCell style={{ padding: '8px' }}>
                <TextField
                  type="number"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ minWidth: 140 }}
                  value={expense.amount}
                  onChange={handleAmountChange(index)}
                  onBlur={handleAmountBlur(index)}
                  InputLabelProps={{ sx: { fontSize: 14 } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {currencies[currency].symbol}
                      </InputAdornment>
                    ),
                  }}
                />
              </TableCell>
              <TableCell style={{ padding: '8px' }} align="right">
                <Button variant="contained" color="error" onClick={() => removeRow(index)} size="small">
                  Remove
                </Button>
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={2} />
            <TableCell align="right" sx={{ paddingRight: '8px', pb: 1 }}>
              <Button variant="contained" color="primary" onClick={addRow} size="small">
                Add Row
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ExpenseTable;
